
import objectFitImages from 'object-fit-images';

//ie objectfit
objectFitImages('img.objImg');

//jquery
window.$ = window.jQuery = require('jquery');
require('slider-pro');

$(window).on("scroll", function () {
  var s = $(this).scrollTop();
  var m = 150;
  if(s > m) {
    $('.footerScroll').fadeIn('slow');
  } else if(s < m) {
    $('.footerScroll').fadeOut('slow');
  }
});

//スムーズスクロール
$('a[href^="#"]').on('click', function() {
var speed = 500;
var href= $(this).attr('href');
var target = $(href == '#' || href == '' ? 'html' : href);
var position = target.offset().top;
$('html, body').animate({scrollTop: position}, speed, 'swing');
return false;
});

//自動電話番号リンク
var ua = navigator.userAgent;
if(ua.indexOf('iPhone') > 0 || ua.indexOf('Android') > 0) {
  $('.telLink').each(function() {
    var str = $(this).text();
    $(this).html($('<a>').attr('href', 'tel:' + str.replace(/-/g, '')).append(str + '</a>'));
  });
}


$(function () {
  $('.headBtn').on('click', function() {
    $('.headNav').toggleClass('on');
    $('.subNavLink').toggleClass('on');
    $(this).toggleClass('on');
  });
  $('.headNavBg').on('click', function() {
    $('.headNav').toggleClass('on');
    $('.subNavLink').toggleClass('on');
    $('.headBtn').toggleClass('on');
  });

});





//slider
$('#indexSlider').sliderPro({
  startSlide: 0,
  arrows: true,
  autoHeight: true,
  heightAnimationDuration: 0,
  autoplay: true,
  slideDistance: 0,
  loop: true,
  buttons: false,
  width: '100%',
  forceSize: 'fullWidth',
  visibleSize: '100%',
  fade: true,
  fadeDuration: 2500,
});


